import { CompanyInfo, Config } from '@websky/core/src/context';
import { getLocale } from '@websky/core/src/utils';
import i18next from 'i18next';
import { Card, CardType } from '@websky/core/src/PromoLoader/types';
import { PromoMessage, PromoMessageIcons } from '@websky/core/src/PromoMessage/types';
import { PassengerTypeConfig } from '@websky/core/src/SearchForm/types';
import { Config as BaggageConfig } from '../../core/src/Baggage/types';
import { BaggageType, OauthServiceType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { StepsEnum } from '../../core/src/types';
import { BaggageDelivery } from './components/Icons/Icons';

import { tg } from './locales/tg';

const currentLocale = getLocale();
const isProd = process.env.NODE_ENV === 'production';

export const nordwindPassengersConfig: PassengerTypeConfig[] = [
	{
		code: 'ADT',
		isAdult: true,
		noAvailableWith: ['МЛА', 'SCF', 'SCM'],
		defaultCount: 1
	},
	/*{
    code: 'GCF',
    isAdult: true,
    parentCode: 'ADT',
    noAvailableWith: ['МЛА', 'SCF', 'SCM']
  },*/
	{
		code: 'CLD',
		isAdult: false
	},
	{
		code: 'INF',
		isAdult: false
	},
	{
		code: 'INS',
		isAdult: false
	},
	{
		code: 'МЛА',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT', 'GCF']
	},
	{
		code: 'SCF',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT', 'GCF']
	},
	{
		code: 'SCM',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT', 'GCF']
	}
];

export const companyInfo: CompanyInfo = {
	multiInsurance: true,
	specialDocumentForInsurance: false,
	facebook: 'https://www.facebook.com/NordwindAirlinesOfficial',
	instagram: 'https://www.instagram.com/nordwindairlines_official',
	vk: 'https://www.instagram.com/nordwindairlines_official',
	twitter: 'https://twitter.com/nordwindair',
	baggage: `https://nordwindairlines.ru/${currentLocale}/baggage`,
	meal: `https://nordwindairlines.ru/${currentLocale}/choose-meal`,
	seat: `https://nordwindairlines.ru/${currentLocale}/choose-seat`,
	legal: `https://nordwindairlines.ru/${currentLocale}/legal`,
	privacyPolicy: `https://nordwindairlines.ru/${currentLocale}/legal/privacy-policy`,
	webskySearchOrder: `https://airbook.nordwindairlines.ru/online/?lang=${currentLocale}/#/search-order`,
	insurance: `https://nordwindairlines.ru/${currentLocale}/services-for-comfort-flight/insurance`,
	loyaltyProgramRegistrationUrl: `https://nordwindairlines.ru/${currentLocale}/club/registration`,
	loyaltyProgramAccountUrl: 'https://nordwindairlines.ru/ru/account#/account/loyalty',
	loyaltyProgramRulesUrl: `https://nordwindairlines.ru/ru/club/rules`,
	loyaltyProgramName: 'Nordwind Club',
	iataCode: 'N4',
	exarePrivacyPolicyURL: `https://nordwindairlines.ru/${currentLocale}/legal/privacy-policy`,
	exareRulesURL: `https://nordwindairlines.ru/${currentLocale}/refunds/refunds-exchange`,
	baggageAnimalsURL: `https://nordwindairlines.ru/${currentLocale}/baggage/animals`,
	loyalty: {
		links: [
			{
				title: 'Statuses',
				url: `https://nordwindairlines.ru/${currentLocale}/club/status`
			},
			{
				title: 'Earn',
				url: `https://nordwindairlines.ru/${currentLocale}/club/earn`
			},
			{
				title: 'Use',
				url: `https://nordwindairlines.ru/${currentLocale}/club/awards`
			},
			{
				title: 'FAQ',
				url: `https://nordwindairlines.ru/${currentLocale}/faq/ffp`
			}
		]
	},
	subsidyFaresConditionURL: ''
};

export const i18n: i18next.Resource = {
	ru: {
		LoginPage: {
			'Please enter a valid Email / Phone / Card number': 'Пожалуйста, введите Эл. почту / Номер карты',
			'Email / Phone / Card number': 'Эл. почта / Номер карты',
			N4_FirstLoginAgreement_Checkbox_Label_1:
				'Я соглашаюсь с <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/ru/legal/privacy-policy#pers">условиями обработки персональных данных</a>',
			N4_FirstLoginAgreement_Checkbox_Label_2:
				'Я ознакомлен с <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/ru/legal/privacy-policy#poly">политикой обработки персональных данных</a>'
		},
		Checkin: {
			"But don't worry, all of our systems have been duplicated several times. You can register on the backup version of the site.":
				'Но не переживайте, все наши системы неоднократно продублированы. Вы можете завершить процесс регистрации на резервной версии сайта.',
			'online check-in is closed for this flight':
				'онлайн-регистрация на данный рейс закрыта. Вы можете пройти регистрацию в аэропорту.',
			'Oops, something went wrong': '',
			'Oops...': '',
			'Service is temporarily unavailable. There are no seats available. Please try again later, or check in at the airport.':
				'Сервис временно недоступен. Нет доступных мест. Обратитесь в <a href="https://help.nordwindairlines.ru/forms/online-checkin-problems" target="_blank">Центр поддержки</a>'
		},
		Title: {
			companyName: 'Nordwind Airlines'
		},
		Passenger: {
			loyaltyNumber: 'Номер карты Nordwind Club',
			'Register now': 'Зарегистрируйтесь и получите <strong>500 миль</strong> в подарок.',
			phone: 'Моб. телефон',
			'Phone number of the same digits is not allowed': 'Введите корректный номер моб. телефона',
			'Incorrect phone number': 'Введите корректный номер моб. телефона'
		},
		Loyalty: {
			Status: 'Статусы',
			'Earn miles': 'Копить',
			'Use miles': 'Тратить',
			'Log in to LightJet Club': 'Вход в личный кабинет Nordwind Club',
			'Forgot password?': 'Восстановить номер карты или пароль',
			'Not a member yet? Join for free!': 'Получить карту',
			miles: 'статусных миль',
			'Oops...': '',
			'How to raise your status': 'Как повысить статус',
			'To upgrade the status, the participant must, within two years from the date of registration in the program, accumulate the number of flight miles or flight segments required to obtain the corresponding status.':
				'Для повышения статуса участнику необходимо в течение двух лет со дня регистрации в программе набрать количество полетных миль или полетных сегментов, необходимых для получения соответствующего статуса.',
			'How to keep your status': 'Как удержать статус',
			'To maintain status, a participant must, within two years from the date of receipt of status in the program, accumulate the number of flight miles or flight segments required to obtain the appropriate status.':
				'Для удержания статуса участнику необходимо в течение двух лет со дня получения статуса в программе набрать количество полетных миль или полетных сегментов, необходимых для получения соответствующего статуса.',
			'The specified email is already in use, please log in to your personal account using the data you provided during registration or restore your card number/password': `Вы уже зарегистрированы в программе лояльности. Для восстановления карты нажмите "У меня уже есть карта" или направьте обращение на почту <a href='mailto:club@nordwindairlines.ru' target="_blank">club@nordwindairlines.ru</a>`
		},
		FlightPrice: {
			Business: 'Комфорт'
		},
		LoyaltyBonus: {
			'LightJet Club': 'Nordwind Club'
		},
		Checkout: {
			'LightJet Club': 'Nordwind Club',
			InsuranceGroupDescr_default:
				'Компенсация расходов в случае задержки или отмены вылета, защита багажа и здоровья на время полёта. Выплата до 700 000 рублей!  </br></br> <small>Страховщик АО «АльфаСтрахование», телефон: 8 800 333 0 999, <a href=\'https://www.alfastrah.ru/\' target=\'_blank\'>alfastrah.ru</a></small>',
			PetPopupRule_0:
				'Авиакомпания принимает к перевозке только комнатных прирученных животных: кошек, собак, птиц, мини-кроликов, ежей, хорьков.',
			PetPopupRule_1: 'Вес контейнера/переноски с питомцем не должен превышать 8 кг.',
			PetPopupRule_2:
				'Габариты жесткого контейнера (клетки) по длине, ширине и высоте не должны превышать 60х35х20 см.',
			PetPopupRule_3:
				'Габариты мягкого контейнера (сумки-переноски закрытого типа) в сумме трех измерений не должны превышать 115 см.',
			PetPopupRule_4: 'На 1 взрослого пассажира разрешается только 1 животное.',
			PetPopupRule_5: '',
			'Your order was archived. Please contact with client support to get a receipt':
				'Заказ был перемещен в архив. Для получения маршрутной квитанции обратитесь в <a href="https://help.nordwindairlines.ru/">Центр поддержки</a>.',
			'Oops..': '',
			'Oops...': '',
			'And back': 'Туда-Обратно',
			'Miles are not credited for this flight.':
				'Мили за данный полёт не начисляются или он уже завершён.\nАктуальный статус начисления миль доступен в Личном кабинете.',
			'Placing an order with a child not accompanied by an adult is prohibited.':
				'Оформление заказа с ребенком, не сопровождаемым совершеннолетним взрослым, запрещено.',
			'The child is too young to fly without an adult':
				'Для оформления билета на не сопровождаемого ребенка отправьте обращение через <strong><a href="https://help.nordwindairlines.ru/forms/buy-ticket-children" target="_blank">Центр поддержки.</a></strong>'
		},
		PaymentForm: {
			'Credit or debit card': 'Карта',
			Title_PayLate: 'Рассрочка - 30 дней без комиссии'
		},
		PromoLoader: {
			NY_banner: 'С новым годом и рождеством',
			NY_banner_text: 'Путешествуйте комфортно с Nordwind airlines',
			'Choose the Optimum tariff': 'Выбирайте тариф Оптимум',
			'Get a discount on services': 'Получите скидку на услуги',
			'Special offer': 'Специальное предложение',
			'Only today! Order meals at a special price!':
				'Только сегодня, добавьте в заказ питание по специальной цене!',
			'Transportation of impressions no limitations': 'Бронируйте сейчас - получите кешбэк 1 000 рублей',
			'Discount on the site up to 50%': 'Удобный способ купить билет с первоначальным взносом 0 рублей!',
			'The top ones get the top seats': 'Лучшие места достаются первым',
			'Be on top!': 'Оставайтесь первыми!'
		},
		Warnings: {
			[`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: 'Представленный способ сервировки и состав блюд гарантирован для рейсов, вылетающих из аэропорта Шереметьево и Пулково, при вылете из других аэропортов питание может отличаться от представленного. При этом вы можете быть уверены, что новые продукты в составе меню не отличаются от изначальных по характеристикам.'
		},
		FlightInfoModalContent: {
			'SelectedFareGroup_View full conditions': 'Описание тарифа'
		},
		MilesRecovery: {
			'Your can get miles for flights your travelled before you signed in loyalty program':
				'Обратите внимание, что восстановление миль возможно:\n\n• только по уже совершённым полётам\n\n• за полёты, совершённые не более 6 месяцев назад.',
			'Order not found':
				'Заказ не найден. Обратитесь в <a href="https://help.nordwindairlines.ru/forms/feedback-online" target="_blank">Центр поддержки пассажиров</a>'
		},
		BaggageService: {
			'You can bring your ski, snowboard, surf equipment, bicycle, golf bag, etc.':
				'Если габариты вашей ручной клади превышают разрешенные размеры 40х30х20 см, вы можете увеличить их'
		},
		IncludedBaggage: {
			Equipment: 'Дополнительный багаж',
			'Need to bring sports, music or baby equipments?': 'Вы можете взять с собой теннисную ракетку.'
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Сэкономьте сейчас до 50%'
		},
		SubsidySuggestPopup: {
			'Subsidy fares': 'Внимание'
		},
		PromoMessage: {
			'Buy now - pay later': 'Берите сейчас – заплатите потом!',
			'You can buy any ticket with credit for 12 months, without an initial payment, with a grace period of 30 days.':
				'На нашем сайте вы можете купить любой билет без первого платежа, на 30 дней без комиссии, с рассрочкой до 12 месяцев.\n<span>Выберите способ оплаты «Рассрочка – 30 дней без комиссии»</span>'
		},
		SeatMap: {
			SeatMap_Standart: 'Эконом'
		},
		Consents: {
			agreement_rules:
				'Я ознакомился(-лась) {{links}}, оплатой данных доп. услуг, принимаю их и согласен с ними.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}{{additionalServiceRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»'
		},
		Contacts: {
			Phone: 'Моб. телефон',
			'Phone number of the same digits is not allowed': 'Введите корректный номер моб. телефона',
			'Incorrect phone number': 'Введите корректный номер моб. телефона'
		},
		Traveller: {
			phone: 'Номер моб. телефона',
			'Please enter a valid phone': 'Введите корректный номер моб. телефона'
		},
		Refund: {
			'To make an exchange please contact a customer support service':
				'Для проведения возврата необходимо обратиться в <a href="https://help.nordwindairlines.ru/forms/change-ticket" target="_blank">Центр поддержки</a>',
			'Oops...': 'Предупреждение'
		},
		Account: {
			'Oops...': '',
			'Travel companions': 'Пассажиры',
			CreateAccountCheckbox: `Я ознакомлен и согласен с <a target='_blank' href='https://nordwindairlines.ru/ru/club/rules'>Правилами программы «Nordwind Club»</a>`
		},
		Exchange: {
			'Oops...': ''
		},
		SearchFormDatepicker: {
			Oops: ''
		},
		Toolbar: {
			'Oops...': ''
		},
		GuardedApolloProvider: {
			'Ops...': ''
		},
		Aeroexpress: {
			'View schedule': 'Расписание'
		}
	},
	de: {
		PromoLoader: {
			NY_banner: 'Merry Christmas and Happy New Year',
			NY_banner_text: 'Happy journeys with Nordwind Airlines',
			'Transportation of impressions no limitations': 'Transport von Eindrücken Keine Einschränkungen',
			'Discount on the site up to 50%': 'Rabatt auf der Website bis zu 50%',
			'The top ones get the top seats': 'Die Ersten bekommen die besten Plätze',
			'Be on top!': 'Gehören Sie zu den Ersten!'
		},
		Title: {
			companyName: 'Nordwind Airlines'
		},
		FlightPrice: {
			Business: 'Comfort'
		},
		Warnings: {
			[`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: `Die vorgestellte Art der Anrichtung und die Zusammenstellung der Gerichte ist für Flüge, die an den Flughäfen Sheremetyevo und Pulkovo beginnen garantiert; bei Abflug ab anderen Flughäfen können die Speisen von den präsentierten Gerichten abweichen. Dabei können Sie versichert sein, dass die neuen Produkte in der Menüzusammenstellung sich nach ihren Eigenschaften nicht von den ursprünglichen unterscheiden.`
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Buy now and save to 50%'
		},
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: `{{insurancesRules}}{{additionalServiceRules}}`,
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		Loyalty: {
			miles: 'statusmeilen'
		}
	},
	en: {
		LoginPage: {
			'Please enter a valid Email / Phone / Card number': 'Please enter a valid Email / Card number',
			'Email / Phone / Card number': 'Email / Card number',
			N4_FirstLoginAgreement_Checkbox_Label_1:
				'I agree to <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/en/legal/privacy-policy#pers">terms of personal data processing</a>',
			N4_FirstLoginAgreement_Checkbox_Label_2:
				'I agree to <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/en/legal/privacy-policy#poly">Personal data processing policy</a>'
		},
		FlightPrice: {
			Business: 'Comfort'
		},
		Title: {
			companyName: 'Nordwind Airlines'
		},
		Passenger: {
			loyaltyNumber: 'Nordwind Club membership card',
			'Register now': 'Sign up and get <strong>500 miles</strong> as a gift.'
		},
		Loyalty: {
			'Log in to LightJet Club': 'Log in to Nordwind Club',
			miles: 'status miles',
			'Oops...': '',
			Status: 'Status',
			'Earn miles': 'Earn miles',
			'Use miles': 'Use miles',
			'How to raise your status': 'How to raise your status',
			'To upgrade the status, the participant must, within two years from the date of registration in the program, accumulate the number of flight miles or flight segments required to obtain the corresponding status.':
				'To upgrade the status, the participant must, within two years from the date of registration in the program, accumulate the number of flight miles or flight segments required to obtain the corresponding status.',
			'How to keep your status': 'How to keep your status',
			'To maintain status, a participant must, within two years from the date of receipt of status in the program, accumulate the number of flight miles or flight segments required to obtain the appropriate status.':
				'To maintain status, a participant must, within two years from the date of receipt of status in the program, accumulate the number of flight miles or flight segments required to obtain the appropriate status.',
			'The specified email is already in use, please log in to your personal account using the data you provided during registration or restore your card number/password': `You are already registered in the loyalty program. To restore the card, click "I have membership" or email <a href='mailto:club@nordwindairlines.ru' target="_blank">club@nordwindairlines.ru</a>`
		},
		LoyaltyBonus: {
			'LightJet Club': 'Nordwind Club'
		},
		Checkout: {
			InsuranceGroupDescr_default:
				'Payments for delayed or canceled flights, baggage protection, and life and health insurance. The amount of payment is up to 700,000 rubles.  </br></br> <small>«AlfaStrakhovanie» JSC, tel: 8 800 333 0 999, <a href=\'https://www.alfastrah.ru/\' target=\'_blank\'>alfastrah.ru</a></small>',

			'LightJet Club': 'Nordwind Club',
			Animal: 'Pet',
			'Your order was archived. Please contact with client support to get a receipt':
				'Your order was archived. Please contact the <a href="https://help.nordwindairlines.ru/">Customer Support</a> to get a receipt.',
			'Oops..': '',
			'Oops...': '',
			'Miles are not credited for this flight.':
				'Miles are not credited for this flight or it has already been completed.\nThe current status of mileage accrual is available in the Personal Account.',
			'Placing an order with a child not accompanied by an adult is prohibited.':
				'Placing an order with a child not accompanied by an adult is prohibited.',
			'The child is too young to fly without an adult': `To issue a ticket for an unaccompanied child, please send a request through <strong><a href="https://help.nordwindairlines.ru/forms/buy-ticket-children" target="_blank">Support Center.</a></strong>`
		},
		Checkin: {
			'online check-in is closed for this flight':
				'online check-in is closed for this flight. You can check in at the airport',
			'Oops, something went wrong': '',
			'Oops...': '',
			'Service is temporarily unavailable. There are no seats available. Please try again later, or check in at the airport.':
				'Service is temporarily unavailable. There are no seats available. Contact the <a href="https://help.nordwindairlines.ru/forms/online-checkin-problems" target="_blank">Support Center</a>'
		},
		PaymentForm: {
			'Credit or debit card': 'Credit card/certificate'
		},
		PromoLoader: {
			NY_banner: 'Merry Christmas and Happy New Year',
			NY_banner_text: 'Happy journeys with Nordwind Airlines',
			'Choose the Optimum tariff': 'Choose the Optimum tariff',
			'Get a discount on services': 'Get a discount on services',
			'Special offer': 'Special offer',
			'Only today! Order meals at a special price!': 'Only today! Order meals at a special price!',
			'Transportation of impressions no limitations': 'Transportation of impressions no limitations',
			'Discount on the site up to 50%': 'Discount on the site up to 50%',
			'The top ones get the top seats': 'The top ones get the top seats',
			'Be on top!': 'Be on top!'
		},
		Warnings: {
			[`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: `Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`
		},
		MilesRecovery: {
			'Your can get miles for flights your travelled before you signed in loyalty program':
				'Attention. Miles are recovered only for flights made 6 months prior to registration in the loyalty program',
			'Order not found':
				'Order not found. Contact <a href="https://help.nordwindairlines.ru/forms/feedback-online" target="_blank">Passenger Support Center</a>'
		},
		BaggageService: {
			'You can bring your ski, snowboard, surf equipment, bicycle, golf bag, etc.':
				'If the dimensions of your carry-on baggage exceed the permitted dimensions of 40x30x20 cm, you can increase its size'
		},
		IncludedBaggage: {
			Equipment: 'Additional baggage',
			'Need to bring sports, music or baby equipments?': 'You can take a tennis racquet with you'
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Buy now and save to 50%'
		},
		SubsidySuggestPopup: {
			'Subsidy fares': 'Attention'
		},
		SeatMap: {
			SeatMap_Standart: 'Economy'
		},
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: `{{insurancesRules}}{{additionalServiceRules}}`,
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		Refund: {
			'To make an exchange please contact a customer support service':
				'Please contact <a href="https://help.nordwindairlines.ru/forms/change-ticket" target="_blank">a customer support service</a>'
		},
		Account: {
			'Oops...': '',
			'Travel companions': 'Passengers',
			CreateAccountCheckbox: `I am familiar with and agree to <a target='_blank' href='https://nordwindairlines.ru/ru/club/rules'>the rules of the program «Nordwind Club»</a>`
		},
		Exchange: {
			'Oops...': ''
		},
		SearchFormDatepicker: {
			Oops: ''
		},
		Toolbar: {
			'Oops...': ''
		},
		GuardedApolloProvider: {
			'Ops...': ''
		}
	},
	fr: {
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: `{{insurancesRules}}{{additionalServiceRules}}`,
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		Loyalty: {
			miles: 'miles de statut'
		}
	},
	kk: {
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: `{{insurancesRules}}{{additionalServiceRules}}`,
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		Loyalty: {
			miles: 'мәртебелік миль'
		}
	},
	zh: {
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules: '{{insurancesProductsLinks}}',
			agreement_interpolation: `{{insurancesRules}}{{additionalServiceRules}}`,
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		}
	},
	tg: tg
};

export const promoMessages: PromoMessage[] = [
	{
		content:
			'You can buy any ticket with credit for 12 months, without an initial payment, with a grace period of 30 days.',
		title: 'Buy now - pay later',
		icon: PromoMessageIcons.TimeIsMoney
	}
];

export const promoLoaders: Card[] = [
	{
		type: CardType.Seats,
		image: `https://cdn.websky.aero/content/N4/images/promo_2.png`,
		title: 'The top ones get the top seats',
		text: 'Be on top!'
	}
];

const baggageConfig: BaggageConfig = {
	baggageLimit: {
		baggageByTypeLimit: [
			{
				baggageType: BaggageType.HandLuggageExcess,
				maxBaggagePerPassenger: 1
			},
			{
				baggageType: BaggageType.CheckedBaggage,
				maxBaggagePerPassenger: 3
			}
		],
		maxBaggagePerPassenger: 10
	}
};

export const config: Config = {
	global: {
		fareGroupVariant: 'big',
		yandexMetrikaId: isProd ? '43824799' : undefined,
		showIsActualizationResultOk: false,
		allowPromoCodes: true,
		showZeroCharges: true,
		maxBaggage: 3,
		maxBaggagePerPassenger: 3,
		baggage: baggageConfig,
		findOrderURL: `https://nordwindairlines.ru/${currentLocale}/booking#/find/`,
		companyInfo,
		dynamicBaggagePricing: false,
		i18n,
		reserveEngines: {
			checkin: 'https://airbook.nordwindairlines.ru/check-in/',
			siteUrl: `https://nordwindairlines.ru/${currentLocale}`
		},
		socialAuthCallbackUrl: 'https://www.nordwindairlines.ru/social-auth',
		socialAuthMethods: [
			{ service: OauthServiceType.Google, isAvailable: true },
			{ service: OauthServiceType.Vkontakte, isAvailable: true },
			{ service: OauthServiceType.TinkoffID, isAvailable: true }
		],
		authMethods: {
			phone: false
		},
		servicesAvailable: {
			animal: true
		},
		stepsAvailable: {
			[StepsEnum.Meal]: false
		},
		FFPRegex: /^\d{8}$/,
		upsaleServices: {
			Baggage: [
				{
					rfisc: 'BD1',
					description: 'Extra delivery baggage',
					icon: BaggageDelivery
				}
			],
			Vip: [
				{
					rfisc: 'BD1',
					description: 'Extra delivery baggage',
					icon: BaggageDelivery,
					extraTitle: 'Extra delivery baggage free for dates',
					extraTitleShowDates: ['2024-03-01T00:00:00Z', '2024-04-20T00:00:00Z'] // start, stop -period to show extraTitle
				}
			]
		},
		seatMap: {
			showRecommendedSeats: true
		},
		insurance: {
			upsaleStrategy: ['checkout-insurance-step']
		},
		additionalResources: {
			extraSvgs: ['https://cdn.websky.aero/content/N4/images/icons.svg']
		}
	},
	Account: {
		engineURL: './booking',
		openCheckinPageOnProfileControlsClick: true,
		showUserPhoneInput: false,
		showSubscribeCheckbox: true
	},
	Engine: {
		calendarDaysCount: 5,
		promoMessages: promoMessages,
		searchFormURL: isProd ? './' : null,
		checkInURL: `./check-in`,
		checkInEnabled: true,
		promoLoaders: promoLoaders,
		showAvailableFaresOnly: true,
		mealWarning: `Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`,
		ignoreBlockedPaymentToReturnOrder: true,
		nas: {
			suggestServicesTypes: [
				OrderAdditionalServiceGdsServiceServiceType.Baggage,
				OrderAdditionalServiceGdsServiceServiceType.Seat,
				OrderAdditionalServiceGdsServiceServiceType.Meal,
				'lounge'
			],
			suggestedServicesOrder: {
				[OrderAdditionalServiceGdsServiceServiceType.Seat]: 4,
				lounge: 3,
				[OrderAdditionalServiceGdsServiceServiceType.Meal]: 2,
				insurance: 1,
				insuranceGroups: 1,
				[OrderAdditionalServiceGdsServiceServiceType.Baggage]: 0
			}
		},
		nasServiceUpsaleForConfirmedOrder: true,
		RTMinPricesForOWFlights: false
	},
	SearchForm: {
		payByMiles: false,
		showPricesInDatepicker: true,
		enableComplexRoute: false,
		passengersConfig: nordwindPassengersConfig,
		selectableCurrencies: [
			{
				code: 'RUB',
				symbol: '₽'
			},
			{
				code: 'USD',
				symbol: '$'
			},
			{
				code: 'EUR',
				symbol: '€'
			},
			{
				code: 'AMD',
				symbol: '֏'
			},
			{
				code: 'KZT',
				symbol: '₸'
			},
			{
				code: 'AZN',
				symbol: '₼'
			},
			{
				code: 'TRY',
				symbol: '₺'
			},
			{
				code: 'SAR',
				symbol: '﷼'
			},
			{
				code: 'AED',
				symbol: 'د.إ'
			}
		]
	},
	FlightStatus: {
		playMarketURL: '',
		appStoreURL: ''
	}
};
